export {default} from './ChannelInvitePeoplePromiseModal'
